import React, { Component } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Link } from "react-router-dom";

import { resetField, getRelatedRecipes } from "../../../../store/actions";
import PlaceholderIMG from "../../../../sharedComponents/placeholderImage";

class RelatedRecipes extends Component {
	componentDidMount() {
		const { recipeId, getRelatedRecipes } = this.props;
		if (recipeId) {
			getRelatedRecipes(recipeId);
		}
	}

	componentDidUpdate(prevProps) {
		const { recipeId, getRelatedRecipes } = this.props;
		if (prevProps.recipeId !== recipeId) {
			getRelatedRecipes(recipeId);
		}
	}

	componentWillUnmount() {
		this.props.resetField("Recipes.relatedRecipes", []);
	}

	render() {
		const { relatedRecipes } = this.props;
		return (
			<div className="related-recipes-wrap">
				<h4 className="title-primary-dark">Similar Recipes</h4>
				{relatedRecipes.map(({ label, data }, index) => {
					return data && data.length ? (
						<div className="mt-3" key={index}>
							<h5 className="bold">{label}</h5>
							<ul className="related-items-list">
								{data.map(({ id, name, main_image }) => {
									return (
										<li key={id} className="related-items-item">
											<Link to={`/nutrition/recipes/${id}/details`}>
												<span className="related-items-item-image">
													<PlaceholderIMG
														src={main_image && main_image.photo_s}
														width="80"
														height="60"
														alt={name}
														bg="rgba(0,0,0,0.1)"
														color="rgba(0,0,0,0.3)"
														objectFit="cover"
													/>
												</span>
												<span className="related-items-item-name">{name}</span>
											</Link>
										</li>
									);
								})}
							</ul>
						</div>
					) : null;
				})}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		relatedRecipes: get(state, "Recipes.relatedRecipes", [])
	};
};

const mapDispatchToProps = { resetField, getRelatedRecipes };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RelatedRecipes);
